import React from 'react';
import {useOutletContext, useParams} from 'react-router-dom';
import ResultsCategory from './ResultsCategory';

const ResultsPage = () => {
  const {category} = useParams();
  const {competitionId} = useOutletContext<{competitionId: number}>();

  return <ResultsCategory category={category!} competitionId={competitionId} />;
};

export default ResultsPage;
